import Evee from 'evee';

export default class AndroidAPI extends Evee {
    constructor() {
        super();

        this.interface = window.PristineAndroid || null;

        this.supported = this.interface != null;
        this.player = null;

        if (this.supported) {
            this.createBindings();
            this.interface.bound();
        }

    }

    setPlayer(player) {
        this.player = player;
    }


    createBindings() {
        this.interface.log = (msg) => {
            console.log(msg);
        };


        this.interface.trackEnded = () => {
            this.emit('playback.end', {});
        };

        this.interface.trackPaused = () => {
            this.emit('playback.pause', {});
        };

        this.interface.trackPlayed = () => {
            this.emit('playback.start', {});
        };

        this.interface.updateTrackLoading = (percent) => {
            this.emit('playback.loading', {
                loaded: percent
            });
        };

        this.interface.next = () => {
            this.emit('controls.next', {});
        };

        this.interface.prev = () => {
            this.emit('controls.prev', {});
        };

        this.interface.updateTrackPosition = (percent, seconds, duration) => {
            this.emit('playback.position', {
                position: percent,
                positionSeconds: seconds,
                duration: duration
            });
        };

    }

    resume() {
        console.log('AAPI: resume');
        this.interface.resume();
    }

    pause() {
        console.log('AAPI: pause');
        this.interface.pause();
    }

    stop() {
        console.log('AAPI: stop');
        this.interface.stop();
    }

    seek(time) {
        console.log('AAPI: seek - '+time);
        this.interface.seek(time);
    }

    seekPercent(percent) {
        console.log('SEEK %', percent);
        this.interface.seekPercent(percent / 100);
    }

    setVolume(amount) {
        this.interface.setVolume(amount);
    }


    playTrack(source, track) {
        console.log('AAPI: play track - '+source);
        var message = JSON.stringify({
            format: 'mp3',
            src: source,
            track: track
        });
        this.interface.playTrack(message);
    }

    prepareNext(source) {
        this.interface.prepareNext(JSON.stringify({
            format: 'mp3',
            src: source,
        }));
    }
}



// WEBPACK FOOTER //
// ./src/AndroidAPI.js